import { IconButton, TextField, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import { textFieldDefaultStyle } from '../../../../components/UI/Typography';

export const OptionIcon = styled(Typography)(() => ({
  marginRight: '10px',
}));

export const OptionCloseIcon = styled(IconButton)(() => ({
  height: '40px',
  marginLeft: '10px',
}));

export const JumpTextField = styled(TextField)(() => ({
  ...textFieldDefaultStyle,
  width: '200px',
  marginLeft: '20px',
}));
